import { IChecklistAnswer } from 'entities/IChecklistAnswer';
import { IInspection } from 'entities/IInspection';
import { handleActions } from 'redux-actions';
import {
  clearInspection,
  getInspection,
  getInspectionTypes,
  categoriesResultSetStatus,
  categoriesResultRemoveStatus,
  categoryResultUpsert,
  inspectionReset,
  setInspectionCategoryIdAnchor,
  getInspectionTypesByType,
  getInspectionTypeById,
  getInspectionChecklist,
  getChecklistType,
  setChecklistQuestionAnswer,
} from 'store/mpi/actions';
import { createSimpleHandler } from '../utils/createSimpleHandler';

import { updateCategoryResults } from './helpers';

export interface IMpiStoreState {
  inspection: IInspection;
  inspectionTypes: any[];
  inspectionCategoryIdAnchor?: string;
  checklistQuestionsAnswers: any;
  safetyChecklist?: any;
}

const defaultState: any = {
  inspection: null,
  inspectionTypes: [],
  inspectionCategoryIdAnchor: undefined,
  checklistQuestionsAnswers: {},
  safetyChecklist: undefined,
};

const reducer = handleActions(
  {
    [getInspectionTypes.typeAPISuccess]: (state, action) => ({
      ...state,
      inspectionTypes: action.payload.data?.inspectionTypes,
    }),
    [getInspectionTypesByType.typeAPISuccess]: (state, action) => ({
      ...state,
      inspectionTypes: action.payload.data?.getInspectionTypesByType,
    }),
    [getInspectionTypeById.typeAPISuccess]: (state, action) => ({
      ...state,
      inspectionTypes: [action.payload.data?.inspectionType],
    }),
    [getInspection.typeAPISuccess]: (state, action) => ({
      ...state,
      inspection: action.payload.data?.inspection,
    }),
    [getChecklistType.typeAPISuccess]: createSimpleHandler('safetyChecklist'),
    [getInspectionChecklist.typeAPISuccess]: (state, action) => {
      const ins: IInspection = action.payload.data?.inspection;
      const questionsAnswers: any = {};
      ins.checklistAnswers.forEach((ca: IChecklistAnswer) => {
        questionsAnswers[ca.checklistQuestionId] = ca;
      });

      return {
        ...state,
        inspection: ins,
        checklistQuestionsAnswers: questionsAnswers,
      };
    },
    [categoriesResultSetStatus.typeAPISuccess]: updateCategoryResults(
      'categoriesResultSetStatus'
    ),
    [categoriesResultRemoveStatus.typeAPISuccess]: updateCategoryResults(
      'categoriesResultRemoveStatus'
    ),
    [categoryResultUpsert.typeAPISuccess]: updateCategoryResults(
      'categoryResultUpsert'
    ),
    [inspectionReset.typeAPISuccess]: (state, action) => ({
      ...state,
      inspection: action.payload.data?.resetInspection,
    }),
    [clearInspection.type]: (state) => ({
      ...state,
      inspection: null,
    }),
    [setInspectionCategoryIdAnchor.type]: createSimpleHandler(
      'inspectionCategoryIdAnchor'
    ),
    [setChecklistQuestionAnswer.type]: (state, action) => ({
      ...state,
      checklistQuestionsAnswers: {
        ...state.checklistQuestionsAnswers,
        ...action.payload,
      },
    }),
  },
  defaultState
);

export default reducer;
